<template>
  <el-drawer
    title="Detalle de Total de Consumos"
    :visible.sync="showDrawerTotalConsumos"
    :before-close="beforeClose"
    size="75%"
    :modal="false"
  >
    <el-card class="card">
      <div>
        <el-row
          class="flex-container-balance"
          style="padding-bottom: 0px; margin-bottom: 0px"
        >
          <el-button
            v-show="!loading_Balance_Data"
            type="primary"
            icon="el-icon-download"
            @click="exportReport"
            >Exportar</el-button
          >
          <el-col :span="7" :offset="1">
            <h2>
              Total de consumos:
              {{ $options.formatMonto(total) }}
              <i class="el-icon-coin"></i>
            </h2>
          </el-col>
          <el-col :span="10" :offset="1">
            <h2>
              Total de galones:
              {{ $options.formatMonto(totalGalones) }}
              <i class="el-icon-goods"></i>
            </h2>
          </el-col>
          <!-- <el-col>
            <rabbey-toolbox
              filter-placeholder="Buscar por nombre"
              filterables
              @filter-search="search = $event"
            />
          </el-col> -->
        </el-row>
        <el-row style="margin-top: 20px">
          <rabbey-table3
            id="tableTotalConsumos"
            :height="600"
            style="overflow: auto"
            ref="customerTable"
            :columns="TotaldeConsumosDetailledColumns"
            v-loading="loading_Balance_Data"
            :search="search"
            :border="true"
            :stripe="true"
            :data="FilteredData"
            :show-summary="true"
            :summary-method="getSummaries"
          />
        </el-row>
      </div>
    </el-card>
  </el-drawer>
</template>

<script>
import { Decimal } from "decimal.js";
import { TotaldeConsumosDetailledColumns } from "@/views/apps/ncfmovil/columnsTables/TotaldeConsumosColumns.js";
import { formatMonto } from "@/utils";
import { exportExcel } from "@/helpers/exportExcel";
export default {
  formatMonto,
  name: "TotaldeConsumosDetail",
  props: {
    showDrawerTotalConsumos: {
      type: Boolean,
      default: false
    },
    CurrentClienData: {
      type: Object,
      default: () => {}
    },
    ClienId: {
      type: Number,
      default: 0
    }
    /*
    SuplierId: {
      type: Number,
      default: 0
    }
    */
  },
  data() {
    return {
      TotaldeConsumosDetailledColumns,
      TotalDeConsumosDataDetail: [],
      loading_Balance_Data: true,
      search: "",
      ClientSelected: "",
      CardHolderFiltered: [],
      FilteredData: [],
      DiffSelected: "All",
      total: 0.0,
      totalGalones: 0.0,
      DiffOptions: [
        {
          value: "All",
          label: "Todos con o sin diferencias de Balances"
        },
        {
          value: "Diff",
          label: "Tiene diferencias de Balances"
        },
        {
          value: "NoTDiff",
          label: "No Tiene diferencias de Balances"
        }
      ]
    };
  },
  mounted() {
    //console.log("this.CurrentClienData: ", this.CurrentClienData)
    this.GetDataConsumptionTotalClient(this.ClienId);
  },
  methods: {
    async exportReport() {
      await exportExcel(
        this.TotaldeConsumosDetailledColumns.map((column) => {
          return column.label;
        }),

        this.FilteredData.map((data) => {
          return [
            data.clienteid,
            data.fechaHora,
            data.tarjetaid,
            data.tipoTarjeta,
            data.tipodeControl,
            data.tarjetahabienteid,
            data.monto,
            data.gal,
            data.producto,
            data.estacion,
            data.estacionPrincipal,
            data.operadorDespachador
          ];
        }),
        "Total de consumos"
      );
    },
    GetDataConsumptionTotalClient(ClienId = null) {
      this.$http
        .get(`/api/tennos/GetDataUserConsumptionTotal?userId=${ClienId}`)
        .then((resp) => {
          this.FilteredData = resp.data;
          let total = new Decimal(0.0);
          let totalGalones = new Decimal(0.0);
          resp.data.forEach((x) => {
            //console.log(total.toNumber())
            total = total.plus(x.monto);
            totalGalones = totalGalones.plus(x.gal);

            //total = parseFloat(total + "") + parseFloat(x.Monto + "");
            //total = total.toFixed(2);
          });
          this.total = total.toNumber();
          this.totalGalones = totalGalones.toNumber();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading_Balance_Data = false;
        });
    },
    beforeClose() {
      this.$emit("closeTotal");
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index < 1) {
          return;
        }
        if (index === 1) {
          sums[index] = "Totales";
          return;
        }
        if (index === 2) {
          sums[index] = "";
          return;
        }
        if (index === 5) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    }
  }
};
</script>

<style lang="css" scoped>
.export-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.flex-container-balance {
  display: flex;
  /*height: 200px;*/
  align-items: center;
}

.supliers_select {
  min-width: 60%;
}

.card {
  margin: 10;
}
</style>
